import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/i18n";

export const NewsletterForm = ({ dark = false, testid = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const { t } = useT();
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="flex gap-2 max-w-sm" data-testid={`${testid}-form`}>
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@yourrental.com"
        className={`field ${dark ? "!bg-[#0b3c49] !border-[#F4E9D8]/20 !text-[#F4E9D8] placeholder:text-[#F4E9D8]/50" : ""}`}
        data-testid={`${testid}-email-input`} />
      <button disabled={busy} className="btn-coral !px-4 shrink-0 text-sm" data-testid={`${testid}-submit-btn`}>{busy ? "…" : t("Subscribe")}</button>
    </form>
  );
};
